import { useEffect } from "react";
import { useLocation } from "wouter";
import { ROUTES_META, DEFAULT_TITLE } from "../data/routes.generated";
const metadata = new Map(ROUTES_META.map(route => [route.path, route]));
const cleanPath = (path: string) => path.split(/[?#]/)[0].replace(/\/+$/, "") || "/";
export function titleForPath(path: string): string {
  return metadata.get(cleanPath(path))?.title || DEFAULT_TITLE;
}
export default function DocumentTitle() {
  const [location] = useLocation();
  useEffect(() => {
    const route = metadata.get(cleanPath(location));
    document.title = route?.title || DEFAULT_TITLE;
    const set = (selector: string, value: string) => document.querySelector(selector)?.setAttribute("content", value);
    set('meta[name="description"]', route?.description || "Kinetic Trust Protocol");
    set('meta[property="og:title"]', document.title);
    set('meta[name="twitter:title"]', document.title);
    set('meta[property="og:description"]', route?.description || "Kinetic Trust Protocol");
    set('meta[name="twitter:description"]', route?.description || "Kinetic Trust Protocol");
    const canonical = route?.canonicalUrl || `https://kinetic-trust-protocol.net${cleanPath(location)}`;
    document.querySelector('link[rel="canonical"]')?.setAttribute("href",canonical);
    set('meta[property="og:url"]',canonical);
    const openWorkspace = location === "/colophon" || /^\/physics(?:\/|$)/.test(location);
    const robots = (route?.indexable || openWorkspace) ? "index, follow, max-snippet:-1, max-image-preview:large" : "noindex, follow";
    set('meta[name="robots"]',robots);
    set('meta[name="googlebot"]',robots);
  }, [location]);
  return null;
}
